module.exports = __webpack_public_path__ + "static/packages-767b161ec39ca7a59e3fdf80ce035136.jpg";